export default __webpack_public_path__ + "static/media/ranes5.3eb125f9.jpg";